import { render, staticRenderFns } from "./commonWord.vue?vue&type=template&id=8d8a7d90&scoped=true&"
import script from "./commonWord.vue?vue&type=script&lang=js&"
export * from "./commonWord.vue?vue&type=script&lang=js&"
import style0 from "./commonWord.vue?vue&type=style&index=0&id=8d8a7d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a7d90",
  null
  
)

export default component.exports